<h2 id="auth-report-list-heading" class="display-none">
  BAER Authorization Report List
</h2>
<table mat-table [dataSource]="reports" class="report-table"
       aria-labelledby="auth-report-list-heading auth-report-list-caption">
    <caption id="auth-report-list-caption" class="usa-sr-only">
      BAER Authorization Report List. Columns: 2500-8 Reports, Total Requested,
      Total Authorized.
    </caption>
    <ng-container matColumnDef="filler">
        <th mat-header-cell *matHeaderCellDef class="filler-column" style="width: 48px;"></th>
        <td mat-cell *matCellDef="let report" class="filler-column"></td>
    </ng-container>
    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>2500-8 Reports</th>
        <td mat-cell *matCellDef="let report"><a [routerLink]="'/report-overview'"
                [queryParams]="{report_id: report.report_id}">{{assessment.baer_name}}({{report.report_num}})</a>
        </td>
    </ng-container>
    <ng-container matColumnDef="fill">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let report"></td>
    </ng-container>
    <ng-container matColumnDef="total_req">
        <th mat-header-cell *matHeaderCellDef style="width: 200px;">
            Total Requested
        </th>
        <td mat-cell *matCellDef="let report" style="width: 200px;">
            {{'$'+(report.total_req ?? 0 | number:'1.2-2') | empty_check}}
        </td>
    </ng-container>
    <ng-container matColumnDef="total_auth">
        <th mat-header-cell *matHeaderCellDef style="width: 200px;">
            Total Authorized
        </th>
        <td mat-cell *matCellDef="let report" style="width: 200px;">
            {{'$'+(report.total_auth ?? 0 | number:'1.2-2') | empty_check}}
        </td>
    </ng-container>
    <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef style="width: 170px;">
            <div class="info-containment-div"></div>
        </th>
        <td mat-cell *matCellDef="let report" style="width: 170px;">
            <button class="btn-only" [routerLink]="'/report-overview'" [queryParams]="{report_id: report.report_id}">
                <fa-icon class="fa-sm" [icon]="faFileLines"></fa-icon>View Report
            </button>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    <!-- Row shown when there is no matching data. -->
    <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="6">
            <div class="no-data">
                <p>No reports have been created</p>
            </div>
        </td>
    </tr>
</table>
